<template>

  <v-container fluid class="px-0 pt-0 vehicle-item">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-1 mb-5">
      <v-col cols="12" class="d-flex align-center justify-start page-breadcrumb-new">
        <!-- (breadcrumb) -->
        <v-icon small class="mr-2">mdi-car</v-icon>
        <router-link :to="{ name: 'vehicle-list' }">Vehicles</router-link>
        <div class="separator">/</div>
        <div class="active-item" v-if="vehicle">{{ vehicle.license_plate }}</div>
      </v-col>
    </v-row>

    <!-- (data loading spinner) -->
    <v-container v-if="isDataLoading" class="d-flex flex-column align-center justify-center">
      <v-progress-circular indeterminate :size="50" style="margin-bottom:30px" color="primary" />
    </v-container>

    <template v-else-if="vehicle">

      <!---------------------------------------->
      <!-- Vehicle Label, Status, and Actions -->
      <!---------------------------------------->
      <v-container fluid>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" lg="4">
            <div class="page-super-title">
              {{ vehicleDisplayName }}
            </div>
            <div class="page-title">{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.vehicle_model }}</div>
            <div class="mt-5">
              <span class="form-field-label">Status:</span>
              <v-chip label outlined :class="`${vehicle.vehicle_status} ml-3`">
                {{ vehicle.vehicle_status }}
              </v-chip>
              <!-- <v-tooltip bottom v-if="receiver.receiver_status !== 'APPROVED'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-2" style="cursor:pointer;font-size:22px;" color="grey darken-1" v-bind="attrs" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <div>While in the pending state, deliveries cannot be dispatched to this location.</div>
                <div>For a receiver to be approved, a valid license with a ship-to address must be configured.</div>
              </v-tooltip> -->
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="8" class="d-flex align-center justify-start">
            <vehicle-status-manager
                :vehicle="vehicle"
                :canEdit="canEdit"
                @updated="loadVehicle" />
          </v-col>
        </v-row>
      </v-container>

      <!--------------------->
      <!-- Vehicle Details -->
      <!--------------------->
      <v-container fluid class="mt-4 pb-5 pt-4 page-content">
        <v-row class="pa-0 ma-0">
          <v-col cols="12" xs="12" sm="12" md="5" lg="4" class="pt-0">
            <span class="title">Vehicle Details</span>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7" lg="8" class="pt-0 d-flex align-center justify-sm-center justify-lg-start">
            <v-btn color="orange darken-3" v-if="canEdit" @click="editItemDetails">
              Edit Details
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col cols="12">
            <div>
              <span class="form-field-label">License plate:</span> {{ vehicle.license_plate }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">Year:</span> {{ vehicle.year }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">Make:</span> {{ vehicle.make }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">Model:</span> {{ vehicle.vehicle_model }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">Color:</span> {{ vehicle.color }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">Last Odometer Reading:</span> {{ vehicle.last_odometer_reading }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">VIN:</span> {{ vehicle.vin_number }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">Notes:</span> {{ vehicle.notes }}
            </div>
          </v-col>
        </v-row>
      </v-container>

    </template>

  </v-container>

</template>

<script>
import VehicleStatusManager from '@/components/vehicles/VehicleStatusManager'

export default {
  name: 'VehicleItemPage',

  components: {
    VehicleStatusManager
  },

  props: {
    vehicleId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      isDataLoading: false,
      dataLoadingError: null,
      vehicle: null
    }
  },

  computed: {
    canEdit () {
      return (this.$root.activeUserHasRole('admin'))
    },
    vehicleDisplayName () {
      if (!this.vehicle) return ''
      return this.vehicle.nickname
        ? `${this.vehicle.license_plate} - ${this.vehicle.nickname}`
        : this.vehicle.license_plate
    }
  },

  async beforeMount () {
    // Ensure vehicle is loaded
    if (!this.vehicle) this.loadVehicle()
  },

  methods: {
    editItemDetails () {
      this.$store.dispatch('sh/setItemToEdit', this.vehicle) // set item to edit
      this.$root.goTo('vehicle-item-edit', { vehicleId: this.vehicle.id }) // go to edit page
    },

    async loadVehicle () {
      this.isDataLoading = true

      try {
        this.vehicle = await this.$store.dispatch('sh/fetchData', {
          resource: 'vehicle',
          id: this.vehicleId
        })
      } catch (err) {
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style scoped>
  .vehicle-item .form-field-label {
    margin-right: 4px;
  }
</style>
